import Vue from 'vue';
import VueI18n from 'vue-i18n';

/**
 * This structure is created according to the folder in this proyect
 *
 */
const messages = {
  'es-CL': {
    message: {
      dinamicform: {
        dinamicform: {
          enviar: 'Enviar',
          cancelar: 'Cancelar'
        },
        selectfield: {
          seleccioneopcion: 'Seleccione opción'
        }
      },
      flow: {
        flowrecordpanel: {
          historia: 'Historia'
        },
        flowsidebar: {
          base: 'Base',
          abrirformulario: 'Abrir Formulario',
          descargarexcel: 'Descargar Excel'
        },
        flow: {
          flujoultimas: 'Flujo últimas 24 horas'
        }
      },
      reports: {
        maintenance: {
          maintenance: 'Indicadores de Mantenimiento',
          dispmaintenance: 'Disponibilidad de Mantenimiento'
        },
        detenciones: {
          paretodetenciones: 'Pareto de Detenciones',
          descargarexcel: 'Descargar Excel'
        },
        indicadores:{
          totaldiario: 'Total diario',
          totalmensual: 'Total mensual',
        },
        indicador: 'Indicadores',
        detencion: 'Detenciones',
        mantenimiento: 'Mantenimiento',
        plan: 'Cumplimiento Plan',
        disp: 'Disponibilidad'
      },
      ui: {
        loginmodal: {
          titulo: 'Error de Autenticación',
          usuarioinvalido:
            'El nombre de usuario o la contraseña son incorrectos.'
        }
      },
      wms: {
        itemstable: {
          codigo: 'Código',
          producto: 'Producto',
          ubicacion: 'Ubicación',
          ingreso: 'Ingreso',
          vencimiento: 'Vencimiento'
        },
        pickingmenu: {
          buscar: 'Buscar',
          nuevaorden: 'Nueva Orden'
        },
        pickingsidebar: {
          anadiritem: 'Añadir Item',
          cancelar: 'Cancelar',
          guardar: 'Guardar'
        },
        pickingtable: {
          codigo: 'Código',
          creacion: 'Creación',
          items: 'Items',
          estado: 'Estado',
          acciones: 'Acciones',
          nuevoitem: 'Nuevo item'
        },
        stock: {
          buscar: 'Buscar',
          nuevoitem: 'Nuevo Item'
        }
      },
      login: {
        usuario: 'Nombre de Usuario',
        password: 'Contraseña',
        arbol: 'Arbol',
        entrar: 'Entrar'
      },
      productionchart: {
        velocidad: 'Velocidad',
        vnominal: 'V. nominal',
        produccionhora: 'Producción hora',
      },
      alertdialog: {
        confirmar: 'Confirmar',
        cancelar: 'Cancelar'
      },
      datatableinteractive: {
        busqueda: 'Busqueda'
      },
      detenciones: {
        detenciones: 'Detenciones',
        agregardetencion: 'Agregar detención',
        simbologia: 'Simbología',
        editardetencion: 'Editar detención',
        agregarnodo: 'Agregar detención',
        activardesactivardetencion: 'Activar / desactivar detención',
        eliminarnodo: 'Eliminar detención',
        titulomodal: 'Detención a agregar/modificar',
        nodopadre: 'Nodo padre',
        avisosinnodopadre: 'Si deja este campo vacío, la detención no sera parte de ninguna otra.',
        description: 'Descripción',
        usointerno: 'Uso interno',
        guardarcambios: 'Guardar cambios',
        nombre: 'Nombre',
        estado: 'Estado',
        habilitado: 'Habilitado',
        desabilitado: 'Deshabilitado',
        opciones: 'Opciones',
        confirmarborrar: '¿Está seguro que desea eliminar esta detención? esta acción no se puede deshacer',
        confirmardesactivar: '¿Está seguro que desea desactivar esta detención?',
        confirmaractivar: '¿Está seguro que desea activar esta detención?',
        codigo: 'Código'
      },
      detentiotable: {
        iniciodetencion: 'Inicio Detención',
        findetencion: 'Fin Detención',
        duraciondetencion: 'Duración Detención',
        codigodetencion: 'Código Detención',
        descripcionusuario: 'Descripción Usuario',
        usuariodetencion: 'Usuario',
        acciones: 'Acciones',
        dividir: 'Dividir'
      },
      devicestats: {
        infodispositivo: 'Información Dispositivo',
        prodacum: 'Prod. Acumulada',
        desde: 'Desde',
        hasta: 'Hasta',
        cambiarproducto: 'Cambiar Producto'
      },
      loadingnotification: {
        cargando: 'Cargando'
      },
      modal: {
        cerrar: 'Cerrar'
      },
      notfound: {
        volver: 'Volver'
      },
      production: {
        nuevaasignacion: 'Nueva Asignación',
        eliminarasignacion: 'Eliminar Asignación',
        notificar: 'Notificar',
        descargarexcel: 'Descargar Excel',
        buscar: 'Buscar',
        limpiar: 'Limpiar',
        tituloeliminar: 'Eliminar Asignación',
        titulomodal: 'Está seguro que desea eliminar la asignación'
      },
      rangeselector: {
        ahora: 'Ahora',
        dias: 'días'
      },
      users: {
        usuarios: 'Usuarios',
        agregarusuario: 'Agregar usuario',
        editarusuario: 'Editar',
        modificarcontrasena: 'Admin. Contraseña',
        modificarestado: 'Modificar estado',
        habilitado: 'Habilitado',
        desabilitado: 'Deshabilitado',
        nombres: 'Nombres',
        apellidos: 'Apellidos',
        email: 'E-mail',
        email2: 'E-mail 2',
        ingresarnuevacontrasena: 'Nueva contraseña',
        verificarcontrasena:'Verificar contraseña',
        tipousuario: 'Tipo de usuario',
        guardarcambios: 'Guardar datos',
        editarusuariotitulo: 'Editar usuario',
        editarcontrasenatitulo: 'Modificar contraseña',
        identificador: 'Identificador',
        pin: 'Pin',
        nombreusuario: 'Nombre de usuario',
        formatocontrasena: 'Contraseña debe contener mayúsculas y minúsculas',
        acciones: 'Acciones',
        estado: 'Estado',
        errorcontrasena: 'Contraseñas deben ser iguales',
        mensajeerror: 'Ha ocurrido un error, contacte a un administrador',
        Administrador: 'Administrador',
        Ingenieria: 'Ingenieria',
        Operador: 'Operador',
        Visita: 'Visita',
      },
      wmspickingtable: {
        codigo: 'Código',
        producto: 'Producto',
        ubicacion: 'Ubicación',
        ingreso: 'Ingreso',
        vencimiento: 'Vencimiento'
      },
      device: {
        acciones: 'Acciones',
        dividirdetencion: 'Dividir'
      },
      base: 'Base',
      cerrarsesion: 'Cerrar sesión',
      configuracion: 'Configuración',
      dashboard: 'Dashboard',
      inicio: 'Inicio',
      movimientos: 'Movimientos',
      nombresesion: 'Sesión iniciada como',
      picking: 'Picking',
      produccion: 'Producción',
      reportes: 'Reportes',
      stock: 'Stock',
      ubicaciones: 'Ubicaciones',
      usuarios: 'Usuarios',
      detencion: 'Detenciones'
    }
  },
  'pt-BR': {
    message: {
      dinamicform: {
        dinamicform: {
          enviar: 'Enviar',
          cancelar: 'Cancelar'
        },
        selectfield: {
          seleccioneopcion: 'Selecione a opção'
        }
      },
      flow: {
        flowrecordpanel: {
          historia: 'História'
        },
        flowsidebar: {
          base: 'Base',
          abrirformulario: 'Abrir Formulário',
          descargarexcel: 'Baixar Excel'
        },
        flow: {
          flujoultimas: 'Formulário'
        }
      },
      reports: {
        maintenance: {
          maintenance: 'Indicadores de Manutenção',
          dispmaintenance: 'Disponibilidade de Manutenção'
        },
        detenciones: {
          paretodetenciones: 'Pareto de Motivos de Parada',
          descargarexcel: 'Baixar Excel'
        },
        indicadores:{
          totaldiario: 'Total diário',
          totalmensual: 'Total mensal',
        },
        indicador: 'Indicadores',
        detencion: 'Paradas',
        mantenimiento: 'Manutenção',
        plan: 'Conformidade do Plano',
        disp: 'Disponibilidade'
      },
      ui: {
        loginmodal: {
          titulo: 'Erro de Autenticação',
          usuarioinvalido: 'O Nome de Usuário ou Senha Estão Errados.'
        }
      },
      wms: {
        itemstable: {
          codigo: 'Código',
          producto: 'Produto',
          ubicacion: 'Localização',
          ingreso: 'Entrada',
          vencimiento: 'Vencimento'
        },
        pickingmenu: {
          buscar: 'Salvar',
          nuevaorden: 'Nova ordem'
        },
        pickingsidebar: {
          anadiritem: 'Adicionar Item',
          cancelar: 'Cancelar',
          guardar: 'Salvar'
        },
        pickingtable: {
          codigo: 'Código',
          creacion: 'Criação',
          items: 'Items',
          estado: 'Estado',
          acciones: 'Ações',
          nuevoitem: 'Novo item'
        },
        stock: {
          buscar: 'Buscar',
          nuevoitem: 'Novo item'
        }
      },
      login: {
        usuario: 'Nome de Usuário',
        password: 'Contra senha',
        arbol: 'Arbol',
        entrar: 'Entrar'
      },
      productionchart: {
        velocidad: 'Velocidade',
        vnominal: 'V. nominal',
        produccionhora: 'Produção hora',
      },
      alertdialog: {
        confirmar: 'Confirmar',
        cancelar: 'Cancelar'
      },
      datatableinteractive: {
        busqueda: 'Buscar'
      },
      detenciones: {
        detenciones: 'Gerenciar paradas',
        agregardetencion: 'Adicionar paradas',
        simbologia: 'Simbologia',
        editardetencion: 'Editar parada',
        agregarnodo: 'Adicionar parada',
        activardesactivardetencion: 'Ativar / desativar detención',
        eliminarnodo: 'Remover detención',
        titulomodal: 'Parada a adicionar / modificar',
        nodopadre: 'Parada pai',
        avisosinnodopadre: 'Se você deixar este campo vazio, a parada não fará parte de nenhuma outra.',
        description: 'Descrição',
        usointerno: 'Uso interno',
        guardarcambios: 'Guardar mudanças',
        nombre: 'Nomes',
        estado: 'Status',
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        opciones: 'Opções',
        confirmarborrar: 'Tem certeza de que deseja excluir esta parada? Essa ação não pode ser desfeita',
        confirmardesactivar: 'Tem certeza de que deseja desativar esta parada?',
        confirmaractivar: '¿Tem certeza de que deseja ativar esta detención?',
        codigo: 'Código'
      },
      detentiotable: {
        iniciodetencion: 'Inicio Parada',
        findetencion: 'Fim da parada',
        duraciondetencion: 'Duração da Parada',
        codigodetencion: 'Código de parada',
        descripcionusuario: 'Descripção do Usuário',
        usuariodetencion: 'Usuário',
        acciones: 'Ações',
        dividir: 'Dividir'
      },
      devicestats: {
        infodispositivo: 'Informação de máquina',
        prodacum: 'Produção Acumulada',
        desde: 'De',
        hasta: 'Até',
        cambiarproducto: 'Alterar produto'
      },
      loadingnotification: {
        cargando: 'Carregando'
      },
      modal: {
        cerrar: 'Sair'
      },
      notfound: {
        volver: 'Retornar'
      },
      production: {
        nuevaasignacion: 'Nova atribuição',
        eliminarasignacion: 'Excluir Atribuição',
        notificar: 'Notificar',
        descargarexcel: 'Baixar Excel',
        buscar: 'Buscar',
        limpiar: 'Limpar',
        tituloeliminar: 'Excluir atribuição',
        titulomodal: 'Tem certeza de que deseja remover a atribuição'
      },
      rangeselector: {
        ahora: 'Agora',
        dias: 'dias'
      },
      users: {
        usuarios: 'Usuários',
        agregarusuario: 'Adicionar usuário',
        editarusuario: 'Editar',
        modificarcontrasena: 'Admin. senha',
        modificarestado: 'Modificar status',
        habilitado: 'Ativado',
        desabilitado: 'Desativado',
        nombres: 'Nome',
        apellidos: 'Sobrenome',
        email: 'E-mail',
        email2: 'E-mail 2',
        ingresarnuevacontrasena: 'Senha',
        verificarcontrasena:'Confirme a senha',
        tipousuario: 'Tipo de usuário',
        guardarcambios: 'Salvar dados',
        editarusuariotitulo: 'Editar usuário',
        editarcontrasenatitulo: 'Alterar senha',
        identificador: 'Identificador',
        pin: 'Pim',
        nombreusuario: 'Nome de usuário',
        formatocontrasena: 'A senha deve conter letras maiúscula e minúscula, com 8 caracteres (letras e números)',
        acciones: 'Ações',
        estado: 'Status',
        errorcontrasena: 'As senhas devem ser as mesmas',
        mensajeerror: 'Ocorreu um erro, entre em contato com um administrador',
        Administrador: 'Administrador',
        Ingenieria: 'Engenharia',
        Operador: 'Operador',
        Visita: 'Visita',
      },
      wmspickingtable: {
        codigo: 'Código',
        producto: 'Produto',
        ubicacion: 'Localização',
        ingreso: 'Entrada',
        vencimiento: 'Vencimiento'
      },
      device: {
        acciones: 'Ações',
        dividirdetencion: 'Dividir'
      },
      cerrarsesion: 'Sair',
      inicio: 'Inicio',
      produccion: 'Produção',
      reportes: 'Relatórios',
      dashboard: 'Dashboard',
      base: 'Base',
      stock: 'Stock',
      picking: 'Picking',
      movimientos: 'Movimientos',
      ubicaciones: 'Ubicaciones',
      nombresesion: 'Logado como',
      configuracion: 'Configuração',
      usuarios: 'Usuários',
      detencion: 'Gerenciar paradas'
    }
  }
};

export const getLocale = () => {
  const locale = Intl.NumberFormat().resolvedOptions().locale;
  if (!messages[locale]) return 'es-CL';
  return locale;
};

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: getLocale(),
  messages
});

export default i18n;
